import React, { PureComponent } from 'react';
import WND from './WND.js';
import ICONS from './ICONS';

export default class CDSAMPLE extends WND {
    applicationContent() {
        return <div className="cd-sampler" style={{
            "backgroundColor": "black",
            "height": "100%",
            "width": "100%"
        }}>
            <video src="/Cdsample.mp4" style={{
                "padding": "30px",
                "boxSizing": "border-box",
                "width": "100%",
                "height": "100%"
            }} autoPlay playsInline onEnded={() => {

                // TODO MsgBox

                window.WINAPI.CloseWindow(this.props.hwnd);  
            }}/>
        </div>;
    }

    icon() {
        return ICONS.CDSAMPLE_16;
    }

    title() {
        return "Microsoft Interactive CD Sampler";
    }
}


// WEBPACK FOOTER //
// ./src/walleris/CDSAMPLE.js